export default __webpack_public_path__ + "static/media/modern-fire-fighting.04768a52.jpg";